import {StoreProvider} from 'lowkey-component';

import {IVoiceState} from '@services/types';
import {
  currentVoiceModalIndex,
  isOpenVoiceDialogSaved,
} from '@store/voiceSlice';

export const createVoiceState = (): IVoiceState => {
  const store = StoreProvider.create();
  return {
    updateCurrentVoiceModalIndex: (index: number) => {
      store.dispatch(currentVoiceModalIndex(index));
    },
    updateIsOpenVoiceModal: (isOpen: boolean) => {
      store.dispatch(isOpenVoiceDialogSaved(isOpen));
    },
  };
};
